export default __webpack_public_path__ + "static/media/snowboarding.5094c6e1.jpeg";